import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createBuildingAdmin } from '../../store/buildings';
import { useLoadAppData } from '../../hooks/useLoadAppData';


function AddBuildingPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useLoadAppData();
  const sessionUser = useSelector(state => state.session.user);
  const accounts = useSelector(state => Object.values(state.accounts));



  const [formData, setFormData] = useState({
    building_name: '',
    location: '',
    building_door_number: '',
    account_id: sessionUser?.is_admin ? '' : sessionUser?.account_id
  });

  const [errors, setErrors] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'building_door_number' && !/^\d*$/.test(value)) {
      return;
    }

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  if (isLoading) {
    return <div className="p-5 text-7xl">Loading...</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = [];

    if (!formData.building_name) validationErrors.push('Building name is required');
    if (!formData.building_door_number) validationErrors.push('Door number is required');
    if (sessionUser?.is_admin && !formData.account_id) validationErrors.push('Account is required');

    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const result = await dispatch(createBuildingAdmin(formData));
      if (result) {
        history.push('/');
      }
    } catch (error) {
      setErrors([error.toString()]);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-8xl font-bold mb-5 text-center text-blue-600">Add New Building</h1>

        {errors.length > 0 && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            <ul className="list-disc list-inside">
              {errors.map((error, idx) => (
                <li key={idx}>{error}</li>
              ))}
            </ul>
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-lg p-8">
          <div className="space-y-6">
            {sessionUser?.is_admin && (
              <div>
                <label className="block text-2xl font-medium text-gray-700 mb-2">
                  Account <span className="text-red-500">*</span>
                </label>
                <select
                  name="account_id"
                  value={formData.account_id}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg text-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select Account</option>
                  {accounts.map((account) => (
                    <option key={account.id} value={account.id}>
                      {account.account_name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div>
              <label className="block text-2xl font-medium text-gray-700 mb-2">
                Building Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="building_name"
                value={formData.building_name}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-lg text-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label className="block text-2xl font-medium text-gray-700 mb-2">
                Number of Dock Doors <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="building_door_number"
                value={formData.building_door_number}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-lg text-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div className="flex justify-end gap-4 mt-8 pt-6 border-t">
              <button
                type="button"
                onClick={() => history.goBack()}
                className="px-6 py-3 text-2xl text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-all duration-200 w-1/4"
              >
                Cancel
              </button>
              <button id='add-building-button'
                type="submit"
                className="px-6 py-3 text-2xl text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-all duration-200 w-1/4"
              >
                Add Building
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddBuildingPage;
